import axios from 'axios'
import qs from 'qs'
import { getConfig } from './config'

axios.defaults.baseURL = getConfig('VUE_APP_PORTAL_URL')
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.headers.put['Content-Type'] = 'application/json'

axios.defaults.paramsSerializer = (p) =>
  qs.stringify(p, { arrayFormat: 'brackets' })

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.reject(error)
  },
)
